// ==============================|| ACTIVE ACCOUNT STORAGE ||============================== //
//
// The id of the account the console is working as. It lives in localStorage so a reload keeps it, and the
// axios layer reads it on every `/v1/dev/*` call. Storage can be blocked or throw (private windows), so every
// access is guarded and the value is also kept in memory: without storage the choice just does not survive
// a reload.

export const ACTIVE_ACCOUNT_KEY = 'raya_console_account';

let memory: string | null | undefined;

export const readActiveAccount = (): string | null => {
  if (memory !== undefined) return memory;

  try {
    memory = window.localStorage.getItem(ACTIVE_ACCOUNT_KEY) || null;
  } catch {
    memory = null;
  }

  return memory;
};

export const writeActiveAccount = (id: string | null): void => {
  memory = id || null;

  try {
    if (id) {
      window.localStorage.setItem(ACTIVE_ACCOUNT_KEY, id);
    } else {
      window.localStorage.removeItem(ACTIVE_ACCOUNT_KEY);
    }
  } catch {
    // Kept in memory only.
  }
};
